import { getImageUrl } from '@/utils/urls';
import { ImageSquare } from '@liveauctioneers/hammer-ui-core/icons';
import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
    catalogId: number;
    className?: string;
    handleClick: (event: React.SyntheticEvent) => void;
    imageVersion: number;
    itemId: number;
    mobile?: boolean;
    photo: number;
    sellerId: number;
};

const CarouselThumbnail = ({
    catalogId,
    className,
    handleClick,
    imageVersion,
    itemId,
    mobile = false,
    photo,
    sellerId,
}: Props) => {
    return (
        <Container
            $mobile={mobile}
            className={className}
            onClick={handleClick}
        >
            <img
                src={getImageUrl({
                    catalogId,
                    height: 213,
                    imageNumber: photo,
                    imageVersion,
                    itemId,
                    sellerId,
                    width: 213,
                })}
            />
            <Overlay />
            <ImageSquare
                className="absolute cursor-pointer bg-background-info-dark p-2xs opacity-0 transition-all"
                color="inverse"
                style="bold"
            />
        </Container>
    );
};

export default CarouselThumbnail;

const Overlay = styled.div`
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
    opacity: 0;
    background: ${({ theme }) => theme.colors.shadowOverlay600};
    transition: all 0.25s ease-in-out;
`;

const Container = styled.div<{ $mobile: boolean }>`
    position: absolute;
    bottom: -5px;
    right: -5px;
    border: 1px solid ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.black};
    z-index: 1000;
    width: 213px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    ${({ $mobile }) =>
        $mobile &&
        css`
            width: 100px;
            height: 56px;
            border: 2px solid ${({ theme }) => theme.colors.black};
            bottom: 0;
            right: 0;
        `}

    &:hover {
        svg {
            opacity: 1;
        }

        > div {
            && {
                opacity: 1;
            }
        }
    }

    img {
        max-width: 100%;
        max-height: 100%;
    }
`;
